import AlertCircle from "@untitled-ui/icons-react/build/esm/AlertCircle";
import AlertTriangle from "@untitled-ui/icons-react/build/esm/AlertTriangle";
import Plus from "@untitled-ui/icons-react/build/esm/Plus";
import Snowflake02 from "@untitled-ui/icons-react/build/esm/Snowflake02";
import { useContext, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import PopupContext from "../../../../../PopupContext";
import * as Library from "../../../../../utils/Library";
import BtnLargeSolid from "../../../../common/buttons/BtnLargeSolid";
import CheckboxVector from "../../../../common/checkbox/CheckboxVector";
import FormField from "../../../../common/forms/FormField";
import FullScreenOverlay from "../../../../common/overlay/FullScreenOverlay";
import { DialogWithIcon } from "../../POSExportPage";
import SimpleLoadingSpinner from "../../../../common/loaders/SimpleLoadingSpinner";
import TooltipWithInfoCircle from "../../../../common/tooltip/TooltipWithInfoCircle";

// #region SCOPED STYLES
const StyledSeasonsTablePopupV2 = styled.div`
    & {
        width: 673px;
        text-align: start;
    }

    .season-lifecycle .Frame48LeftContent {
        width: 16px;
        border: none;
        margin-left: 8px;
        color: var(--text-and-icons-gray-200, #7c868b);
        position: relative;
        top: -1px;
    }

    .table-list-simple {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 8px;
        padding: 12px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        overflow: visible;
    }

    .popup-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        width: 100%;
        padding-top: 9px;
        padding-bottom: 21px;
        border-bottom: 1px solid var(--backgrounds-and-lines-n-100, #3c485a);
        margin-bottom: 8px;
    }

    .header-title-container,
    .header-actions,
    .header-label {
        display: flex;
        align-items: center;
    }

    .header-title-container {
        gap: 8px;
    }

    .header-actions {
        gap: 8px;
    }

    .header-icon {
        width: 16px;
        height: 16px;
        color: var(--text-and-icons-green-500, #00bb00);
    }

    .header-title {
        color: var(--text-and-icons-green-500, #00bb00);
        font-size: 14px;
        font-weight: 400;
        text-transform: uppercase;
        position: relative;
        top: 1px;
    }

    .popup-content {
        display: flex;
        flex-direction: column;
        gap: 14px;
        align-self: stretch;
        width: 100%;
    }

    .bulk-action-section {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-self: stretch;
    }

    .bulk-action-row {
        display: grid;
        grid-template-columns: 1fr 260px 29px;
        gap: 10px;
        align-items: center;
        padding: 0 8px;
    }

    .bulk-label {
        color: var(--text-and-icons-gray-300, #4f5b6d);
        text-align: right;
        font-size: 14px;
        font-weight: 400;
    }

    .bulk-add-btn {
        background: var(--buttons-all-platforms-gray-500, #10141b);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 29px;
        height: 27px;
        flex-shrink: 0;
    }

    .bulk-add-btn.enabled:hover {
        box-shadow: 0px 0px 0px 1px #ff8c00;
    }

    .plus {
        width: 16px;
        height: 16px;
    }

    .save-warning {
        color: var(--text-and-icons-orange-500, #ff9900);
        font-size: 12px;
        font-weight: 400;
        text-align: center;
        align-self: stretch;
    }

    .divider,
    .divider-2 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px 0 0 0;
        width: 100%;
        height: 0px;
    }

    .divider-2 {
        border-color: #262e3e;
    }

    .season-grid-row {
        display: grid;
        grid-template-columns: 36px minmax(145px, 1fr) 202px 202px;
        gap: 10px;
        align-items: center;
        align-self: stretch;
        width: 100%;
        box-sizing: border-box;
        padding: 8px;
    }

    .checkbox-cell {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .header-label {
        gap: 4px;
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-size: 14px;
        font-weight: 400;
    }

    .table-scroll-area {
        display: flex;
        align-self: stretch;
        overflow-y: auto;
        max-height: 840px;
    }

    .table-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
        flex: 1;
    }

    .table-item {
        border-radius: 4px;
        display: flex;
        align-items: center;
        //min-height: 35px;
    }

    .table-item.even {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
    }

    .item-name {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
    }

    .empty-seasons-state {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        align-self: stretch;
        padding: 4px 0px 8px 0px;
    }

    .empty-seasons-title {
        display: flex;
        align-items: center;
        gap: 8px;
        color: var(--text-and-icons-orange-500, #ff9900);
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
    }

    .empty-seasons-icon {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    .empty-seasons-description {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
    }

    /* Keep the natural height, with room to scroll on short viewports. */
    & {
        display: flex;
        flex-direction: column;
        min-height: 0;
        max-height: calc(100vh - 32px);
        max-height: calc(100dvh - 32px);
    }

    .table-list-simple {
        min-height: 0;
        overflow-y: auto;
    }

    .table-list-simple > * {
        flex-shrink: 0;
    }

    .table-scroll-area {
        flex-shrink: 1;
        /* Retain a readable scroll target if controls exceed the viewport. */
        min-height: 44px;
    }

    .table-body {
        align-self: flex-start;
    }

    .table-body > * {
        flex-shrink: 0;
    }
`;
// #endregion

const getDateInputValue = date => {
    if (!date || date === "-") return "";

    const dateValue = String(date);
    if (dateValue.includes("T")) return dateValue.split("T")[0];
    return dateValue;
};

export default function POSSeasonsTablePopup({
    show,
    onClose,
    seasonMappings = [],
    setSeasonMappings,
    setSaveButtonEnabled,
    posExportRequestData
}) {
    // #region VARS
    const { setGenericConfirmationPopup } = useContext(PopupContext);
    const [hideMainPopup, setHideMainPopup] = useState(false);
    const [bulkText, setBulkText] = useState("");
    const [bulkChangeBtnEnabled, setBulkChangeBtnEnabled] = useState(false);
    const [newSeasonMappings, setNewSeasonMappings] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    // #endregion

    // #region COMPUTED VALUES AND MEMOS
    const {
        labelBrandProducts = [],
        labelBrandSeasons = [],
        seasonsFromPOS = [],
        labelBrandSeasonsMatches = []
    } = posExportRequestData || {};

    const showNoDataMessage = labelBrandProducts.length === 0;
    const hasChecked = newSeasonMappings.some(s => s.isChecked);
    const allChecked = newSeasonMappings.length > 0 && newSeasonMappings.every(s => s.isChecked);

    const posSeasonOptions = useMemo(() => {
        return seasonsFromPOS.map(season => ({
            id: season?.seasonIdFromPOS,
            name: season?.seasonNameFromPOS,
            value: season?.seasonNameFromPOS,
            seasonIdFromPOS: season?.seasonIdFromPOS,
            endOfLifecycleDay: getDateInputValue(season?.endOfLifecycleDay),
            isNOOS: season?.isNOOS === true
        }));
    }, [seasonsFromPOS]);

    const sourceSeasonMappings = useMemo(() => {
        const mappings = labelBrandSeasons.map(labelBrandName => {
            const savedMapping = seasonMappings.find(mapping => mapping?.labelBrandName === labelBrandName);
            const requestMatch = labelBrandSeasonsMatches.find(match => match?.labelBrandName === labelBrandName);
            const exportName = savedMapping?.exportName ?? requestMatch?.exportName ?? null;
            const selectedPOSSeason = posSeasonOptions.find(posSeason => posSeason?.name === exportName);
            const isNOOS = selectedPOSSeason?.isNOOS === true;

            return {
                labelBrandName,
                exportName,
                seasonIdFromPOS: savedMapping?.seasonIdFromPOS ?? selectedPOSSeason?.seasonIdFromPOS ?? null,
                endOfLifecycleDay: isNOOS
                    ? ""
                    : (savedMapping?.endOfLifecycleDay ?? selectedPOSSeason?.endOfLifecycleDay ?? ""),
                isNOOS,
                isChecked: false
            };
        });

        const lifecycleByPOSSeasonID = new Map();

        mappings.forEach(season => {
            if (season.isNOOS === true) return;
            if (season.seasonIdFromPOS === null || season.seasonIdFromPOS === undefined) return season;

            const lifecycleDay = getDateInputValue(season.endOfLifecycleDay);
            const savedLifecycleDay = lifecycleByPOSSeasonID.get(season.seasonIdFromPOS);

            if (!lifecycleByPOSSeasonID.has(season.seasonIdFromPOS) || (!savedLifecycleDay && lifecycleDay)) {
                lifecycleByPOSSeasonID.set(season.seasonIdFromPOS, lifecycleDay);
            }
        });

        return mappings.map(season => {
            if (season.isNOOS === true) return { ...season, endOfLifecycleDay: "" };
            if (season.seasonIdFromPOS === null || season.seasonIdFromPOS === undefined) return season;

            return {
                ...season,
                endOfLifecycleDay: lifecycleByPOSSeasonID.get(season.seasonIdFromPOS) ?? ""
            };
        });
    }, [labelBrandSeasons, labelBrandSeasonsMatches, posSeasonOptions, seasonMappings]);

    const isDirty = useMemo(() => {
        return newSeasonMappings.some(newSeason => {
            const oldSeason = sourceSeasonMappings.find(s => s.labelBrandName === newSeason.labelBrandName);

            return (
                (newSeason.exportName ?? null) !== (oldSeason?.exportName ?? null) ||
                (newSeason.seasonIdFromPOS ?? null) !== (oldSeason?.seasonIdFromPOS ?? null) ||
                newSeason.isNOOS !== oldSeason?.isNOOS ||
                getDateInputValue(newSeason.endOfLifecycleDay) !== getDateInputValue(oldSeason?.endOfLifecycleDay)
            );
        });
    }, [newSeasonMappings, sourceSeasonMappings]);

    const allSeasonsReady =
        newSeasonMappings.length > 0 &&
        newSeasonMappings.every(
            season =>
                season.exportName !== null &&
                season.exportName !== undefined &&
                (season.isNOOS === true || getDateInputValue(season.endOfLifecycleDay))
        );

    const isSaveEnabled = !showNoDataMessage && !hasChecked && isDirty && allSeasonsReady;
    const showSaveWarning = !showNoDataMessage && (hasChecked || !allSeasonsReady);
    const isBulkChangeBtnEnabled = bulkChangeBtnEnabled && hasChecked;
    // #endregion

    // #region FUNCTIONS
    const showSuccessToast = () => {
        Library.showToastMessage({
            type: "success",
            title: "Seasons linked!",
            description: "Your brand seasons are now linked to your POS seasons."
        });
    };

    const handleCloseClicked = () => {
        if (isDirty) {
            setHideMainPopup(true);
            Library.showConfirmationMessage({
                setGenericConfirmationPopup,
                useV2: true,
                headingText: "ATTENTION!!",
                headingColor: "var(--text-icons-orange-500, #FF9800)",
                title: (
                    <DialogWithIcon className="frame-160">
                        <AlertTriangle className="help-circle" style={{ color: "#FF9800" }} />
                        <div className="frame-286">
                            <div className="title">Leaving without saving</div>
                        </div>
                    </DialogWithIcon>
                ),
                messageHtml: "You are leaving without saving.<br/>Confirm you want to proceed",
                confirmText: "PROCEED",
                cancelText: "CANCEL",
                confirmState: "secondary",
                cancelState: "secondary",
                confirmTextColor: "var(--buttons-all-platforms-orange-500, #FF9800)",
                onConfirmClicked: () => {
                    setHideMainPopup(false);
                    onClose();
                },
                onCancelClicked: () => {
                    setHideMainPopup(false);
                }
            });
        } else {
            setHideMainPopup(false);
            onClose();
        }
    };

    const getPOSSeasonOptionByName = seasonName => {
        return posSeasonOptions.find(posSeason => posSeason?.name === seasonName);
    };

    const getLifecycleDayForPOSSeason = (posSeason, currentMappings) => {
        if (posSeason?.isNOOS === true) return "";
        if (posSeason?.seasonIdFromPOS === null || posSeason?.seasonIdFromPOS === undefined) return "";

        const existingMappingForSeason =
            currentMappings.find(
                season =>
                    season?.seasonIdFromPOS === posSeason.seasonIdFromPOS &&
                    getDateInputValue(season?.endOfLifecycleDay)
            ) || currentMappings.find(season => season?.seasonIdFromPOS === posSeason.seasonIdFromPOS);

        if (existingMappingForSeason) return getDateInputValue(existingMappingForSeason.endOfLifecycleDay);
        return posSeason.endOfLifecycleDay ?? "";
    };

    const applyPOSSeasonSelection = (season, posSeason, currentMappings) => ({
        ...season,
        exportName: posSeason?.name ?? null,
        seasonIdFromPOS: posSeason?.seasonIdFromPOS ?? null,
        isNOOS: posSeason?.isNOOS === true,
        endOfLifecycleDay: getLifecycleDayForPOSSeason(posSeason, currentMappings)
    });

    const updateSeasonExportName = (idx, posSeason) => {
        setNewSeasonMappings(prev =>
            prev.map((season, i) => (i === idx ? applyPOSSeasonSelection(season, posSeason, prev) : season))
        );
    };

    const updateSeasonEndOfLifecycleDay = (idx, endOfLifecycleDay) => {
        setNewSeasonMappings(prev => {
            if (prev?.[idx]?.isNOOS === true) return prev;

            const targetSeasonId = prev?.[idx]?.seasonIdFromPOS;

            return prev.map((season, i) => {
                const shouldUpdate =
                    i === idx ||
                    (targetSeasonId !== null &&
                        targetSeasonId !== undefined &&
                        season?.seasonIdFromPOS === targetSeasonId);

                if (!shouldUpdate || season.isNOOS === true) return season;
                return { ...season, endOfLifecycleDay };
            });
        });
    };

    const onSaveClicked = () => {
        if (!isSaveEnabled || isSaving) return;

        setIsSaving(true);
        setTimeout(() => {
            const mappingsToSave = newSeasonMappings.map(season => ({
                labelBrandName: season.labelBrandName,
                exportName: season.exportName,
                seasonIdFromPOS: season.seasonIdFromPOS,
                endOfLifecycleDay: season.isNOOS === true ? "" : getDateInputValue(season.endOfLifecycleDay),
                isNOOS: season.isNOOS === true
            }));

            setSeasonMappings(mappingsToSave);

            if (setSaveButtonEnabled) setSaveButtonEnabled(true);

            setIsSaving(false);
            showSuccessToast();
            setHideMainPopup(false);
            onClose();
        }, 800);
    };

    const handleBulkAdd = () => {
        if (!bulkChangeBtnEnabled || !hasChecked) return;

        setNewSeasonMappings(prev => {
            const selectedPOSSeason = getPOSSeasonOptionByName(bulkText);

            return prev.map(season => {
                if (season.isChecked) {
                    return { ...applyPOSSeasonSelection(season, selectedPOSSeason, prev), isChecked: false };
                }
                return season;
            });
        });

        setBulkText("");
        setBulkChangeBtnEnabled(false);
    };
    // #endregion

    // #region EFFECTS
    // Rebuild only when opening so parent rerenders do not discard unsaved popup edits.
    useEffect(() => {
        if (!show) return;

        setNewSeasonMappings(sourceSeasonMappings);
        setBulkText("");
        setBulkChangeBtnEnabled(false);
    }, [show]); // eslint-disable-line react-hooks/exhaustive-deps
    // #endregion

    // #region RENDER
    return (
        <FullScreenOverlay show={show && !hideMainPopup}>
            <StyledSeasonsTablePopupV2 className="seasons-table-popup">
                <div className="table-list-simple">
                    <div className="popup-header">
                        <div className="header-title-container">
                            <Snowflake02 className="header-icon" />
                            <div className="header-title">CUSTOMIZE SEASONS</div>
                        </div>
                        <div className="header-actions">
                            <BtnLargeSolid
                                title="CLOSE"
                                onClick={handleCloseClicked}
                                normalColor="var(--Buttons-All-Platforms-Gray-500)"
                                hoverColor="var(--Buttons-All-Platforms-Gray-500)"
                                hoverBorderColor="var(--text-icons-orange-500)"
                                textStyle={{
                                    fontSize: "12px",
                                    textTransform: "uppercase"
                                }}
                                style={{
                                    width: "67px",
                                    height: "30px",
                                    padding: "0 10px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            />
                            <BtnLargeSolid
                                title={isSaving ? <SimpleLoadingSpinner /> : "SAVE"}
                                onClick={onSaveClicked}
                                disabled={!isSaveEnabled || isSaving}
                                normalColor="var(--buttons-all-platforms-orange-500, #FF9800)"
                                hoverColor="var(--buttons-all-platforms-orange-400, #FF9800)"
                                disabledColor="var(--buttons-all-platforms-gray-500, #10141b)"
                                textStyle={{
                                    fontSize: "12px",
                                    textTransform: "uppercase",
                                    color:
                                        !isSaveEnabled || isSaving
                                            ? "var(--text-and-icons-gray-300, #4f5b6d)"
                                            : "#ffffff"
                                }}
                                style={{
                                    width: "67px",
                                    height: "30px",
                                    padding: "0 10px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            />
                        </div>
                    </div>

                    {showNoDataMessage && (
                        <div className="empty-seasons-state">
                            <div className="empty-seasons-title">
                                <AlertCircle className="empty-seasons-icon" />
                                <span>NO DATA YET</span>
                            </div>
                            <div className="empty-seasons-description">
                                This could be a new brand in BOtag. Once the first items from this brand are available,
                                you can link your standard seasons to the brand's seasons.
                            </div>
                        </div>
                    )}

                    {!showNoDataMessage && (
                        <>
                            <div className="popup-content">
                                <div className="bulk-action-section">
                                    <div className="bulk-action-row">
                                        <div
                                            className="bulk-label"
                                            style={{
                                                color: hasChecked
                                                    ? "var(--text-and-icons-gray-100, #d1d1d1)"
                                                    : "var(--text-and-icons-gray-300, #4f5b6d)"
                                            }}>
                                            Map selected Brand seasons to POS season:
                                        </div>
                                        <FormField
                                            type="dropdown"
                                            dropdownWithinViewport={true}
                                            varName="season-bulk-change"
                                            styling={{
                                                formFieldWidth: "260px",
                                                formFieldHeight: "27px",
                                                marginBottom: "0px",
                                                dropdownOverlayTop: "35px"
                                            }}
                                            placeholder="Select yours"
                                            isDropdownMultiselect={false}
                                            isDropdownSearchable={true}
                                            dropdownData={posSeasonOptions}
                                            value={hasChecked ? bulkText : ""}
                                            onDropdownChange={item => {
                                                setBulkText(item.name);
                                                setBulkChangeBtnEnabled(true);
                                            }}
                                            requiredType={hasChecked ? "simple" : "disabledSimple"}
                                        />
                                        <div
                                            className={`bulk-add-btn ${isBulkChangeBtnEnabled ? "enabled cursor-pointer" : "disabled hover-not-allowed"}`}
                                            onClick={isBulkChangeBtnEnabled ? handleBulkAdd : null}>
                                            <Plus
                                                className="plus"
                                                color={
                                                    isBulkChangeBtnEnabled
                                                        ? "#FFFFFF"
                                                        : "var(--text-and-icons-gray-300, #7C868B)"
                                                }
                                            />
                                        </div>
                                    </div>

                                    {showSaveWarning && (
                                        <div className="save-warning">
                                            SAVE is only enabled when all brand's seasons have a POS season and all
                                            non-NOOS seasons have End of Lifecycle!
                                        </div>
                                    )}
                                </div>

                                <div className="season-grid-row">
                                    <div className="checkbox-cell">
                                        <CheckboxVector
                                            checkboxColor="#00F260"
                                            onCheckboxClick={() => {
                                                const newValue = !allChecked;
                                                setNewSeasonMappings(prev =>
                                                    prev.map(season => ({ ...season, isChecked: newValue }))
                                                );
                                            }}
                                            isChecked={allChecked}
                                        />
                                    </div>
                                    <div className="header-label">
                                        Brand's seasons
                                        <TooltipWithInfoCircle
                                            iconSize={"14px"}
                                            enabled={true}
                                            header="Brand's seasons"
                                            title={
                                                <>
                                                    These are the season names provided by the Label Brand in the
                                                    product master.
                                                    <br />
                                                    <br />
                                                    Each brand season must be connected to a POS season before the
                                                    season rules can be saved.
                                                    <br />
                                                    <br />
                                                    This does not change the original season name in BOtag. It only
                                                    defines how products from this brand season should be exported and
                                                    handled in Front Systems.
                                                </>
                                            }
                                            width="350px"
                                        />
                                    </div>
                                    <div className="header-label">
                                        Season to POS
                                        <TooltipWithInfoCircle
                                            iconSize={"14px"}
                                            enabled={true}
                                            header="Season to POS"
                                            title={
                                                <>
                                                    Select which POS season this brand season should be exported as in
                                                    Front Systems.
                                                    <br />
                                                    The dropdown shows the seasons saved in your POS season list. You
                                                    can manage this list from My Defaults, where seasons can be added,
                                                    edited, or removed.
                                                    <br />
                                                    Each brand season must have a POS season selected before the season
                                                    rules can be saved.
                                                    <br />
                                                    <br />
                                                    This does not change the original brand season in BOtag. It only
                                                    controls the season value sent to Front Systems.
                                                </>
                                            }
                                            width="350px"
                                        />
                                    </div>
                                    <div className="header-label">
                                        End of Lifecycle
                                        <TooltipWithInfoCircle
                                            iconSize={"14px"}
                                            enabled={true}
                                            header="End of Lifecycle"
                                            title={
                                                <>
                                                    Select the estimated last day products from this season should be
                                                    sold at full price.
                                                    <br />
                                                    <br />
                                                    BOtag uses this date in the reorder algorithm to help score reorder
                                                    urgency.
                                                    <br />
                                                    <br />
                                                    This date can also be managed from My Defaults. If a specific
                                                    product needs its own End of Lifecycle date, it can be adjusted on
                                                    the Product Detail page.
                                                    <br />
                                                    <br />
                                                    POS seasons marked as NOOS (Never Out of Stock) are ongoing and do
                                                    not require an End of Lifecycle date. The NOOS setting is managed
                                                    from My Defaults.
                                                    <br />
                                                    <br />
                                                    Every other brand season must have an End of Lifecycle date before
                                                    the season rules can be saved.
                                                </>
                                            }
                                            width="350px"
                                        />
                                    </div>
                                </div>
                                <div className="divider-2"></div>
                            </div>

                            <div className="table-scroll-area">
                                <div className="table-body">
                                    {newSeasonMappings.map((season, idx) => (
                                        <div
                                            className={`table-item ${idx % 2 === 0 ? "even" : ""}`}
                                            key={`${season.labelBrandName}-${idx}`}>
                                            <div className="season-grid-row">
                                                <div className="checkbox-cell">
                                                    <CheckboxVector
                                                        checkboxColor="#00F260"
                                                        onCheckboxClick={() => {
                                                            setNewSeasonMappings(prev =>
                                                                prev.map((s, i) =>
                                                                    i === idx ? { ...s, isChecked: !s.isChecked } : s
                                                                )
                                                            );
                                                        }}
                                                        isChecked={season.isChecked || false}
                                                    />
                                                </div>
                                                <div className="item-name">{season.labelBrandName}</div>
                                                <FormField
                                                    type="dropdown"
                                                    dropdownWithinViewport={true}
                                                    varName={`season-dropdown-${idx}`}
                                                    styling={{
                                                        formFieldWidth: "100%",
                                                        formFieldHeight: "27px",
                                                        marginBottom: "0px",
                                                        dropdownOverlayTop: "35px"
                                                    }}
                                                    placeholder="Select yours"
                                                    isDropdownMultiselect={false}
                                                    isDropdownSearchable={true}
                                                    dropdownData={posSeasonOptions}
                                                    value={season.exportName ?? ""}
                                                    onDropdownChange={item => updateSeasonExportName(idx, item)}
                                                    requiredType="none"
                                                    useDropdownPortal={true}
                                                />
                                                {season.isNOOS === true ? (
                                                    <FormField
                                                        type="text"
                                                        varName={`season-lifecycle-${idx}`}
                                                        styling={{
                                                            formFieldWidth: "100%",
                                                            formFieldHeight: "27px",
                                                            marginBottom: "0px"
                                                        }}
                                                        value="NOOS (ongoing)"
                                                        requiredType="disabledSimple"
                                                        disableTooltip={true}
                                                        disableAssistiveText={true}
                                                    />
                                                ) : (
                                                    <FormField
                                                        type="date"
                                                        className="season-lifecycle"
                                                        varName={`season-lifecycle-${idx}`}
                                                        styling={{
                                                            formFieldWidth: "100%",
                                                            formFieldHeight: "27px",
                                                            marginBottom: "0px"
                                                        }}
                                                        value={getDateInputValue(season.endOfLifecycleDay)}
                                                        placeholder="Select yours"
                                                        datePickerPlaceholder="Select yours"
                                                        leftContent={<span className="fa-light fa-calendar"></span>}
                                                        onTextChange={date => updateSeasonEndOfLifecycleDay(idx, date)}
                                                        requiredType="none"
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </StyledSeasonsTablePopupV2>
        </FullScreenOverlay>
    );
    // #endregion
}
